export default __webpack_public_path__ + "static/media/products-grid-vertical-theme2.d39d103f.svg";